import React from "react";
import Logo from "../Logo/Logo";
import NavigationMain from "../NavigationMain/NavigationMain";
import classes from "./Header.module.css";
import HeaderTop from "./HeaderTop/HeaderTop";
import { Box } from "@mui/material";

const Header = () => {
  //
  return (
    <header className={classes.header}>
      <HeaderTop />
      <Box className={classes.bottomHeader}>
        <Logo />
        <NavigationMain />
      </Box>
    </header>
  );
};

export default Header;
